export default "__VITE_ASSET__BSGb7bFQ__"